import { ReactNode } from "react";
import { View } from "./View";

export interface IQuickSummaryProps {
  name?: string;
  title: string;
  icon?: ReactNode;
  iconText?: string;
  iconBackground?: string;
  value: ReactNode;
}

export const QuickSummary = (props: IQuickSummaryProps) => {
  return <View {...props} />;
};
